import css from "styled-jsx/css";

export const componentStyles = css`
  .logos-title-component {
    padding: 0 32px;
    text-align: center;
  }
`;
